import moment from 'moment'

import { IAppointmentsReport } from '../../../interface/IAppointmentsReport'
import { IAPIAppointmentsReport } from '../../interface/IAPIAppointmentsReport'

import { createGroupData } from './createGroupData'
import { getGroupByNumber } from './getGroupByNumber'

export const formatForMonth = (
    apiData: IAPIAppointmentsReport[]
): IAppointmentsReport[] => {
    const monthStart: number = moment()
        .clone()
        .isoWeek(getGroupByNumber(apiData[0].date_by_period, 'week'))
        .isoWeek()

    const weeksOfMonthArray = Array.from(
        { length: 4 },
        (v, i) => monthStart + i
    )

    return weeksOfMonthArray.map(
        (weekNumber): IAppointmentsReport =>
            createGroupData(apiData, weekNumber, 'week')
    )
}
